/** Flow E's four routes (E1–E4). */
import type { RouteObject } from 'react-router-dom';
import { withSurfaceStates } from '../../states/boundary.js';
import { E1Activity } from './E1Activity.js';
import { E2Detail } from './E2Detail.js';
import { E3Chat } from './E3Chat.js';
import { E4Support } from './E4Support.js';

/**
 * WP-K · state branches. `withSurfaceStates` wraps every element of this group in the
 * boundary for its matrix column (activity · অ্যাক্টিভিটি); see
 * `apps/web/src/states/boundary.tsx`. It changes nothing about the healthy render — no
 * state resolves unless an API error body says so, so the screens below are untouched
 * and their fidelity gate still measures what it measured.
 */
export const activityRoutes: RouteObject[] = withSurfaceStates('activity', [
  { path: '/activity', element: <E1Activity /> },
  { path: '/activity/:id', element: <E2Detail /> },
  { path: '/activity/:id/chat', element: <E3Chat /> },
  { path: '/activity/:id/support', element: <E4Support /> },
]);
